import {
  EProfileViewActions,
  ProfileViewActions,
} from '@myStore/profile-view/profile-view.actions';
import {
  initialsProfileViewState,
  IProfileViewState,
} from '@myStore/profile-view/profile-view.state';

export const profileViewReducers = (
  state = initialsProfileViewState,
  actions: ProfileViewActions
): IProfileViewState => {
  switch (actions.type) {
    case EProfileViewActions.GetProfileRequest:
      return {
        ...state,
        isLoading: true,
      };
    case EProfileViewActions.GetProfileSuccess:
      return {
        ...state,
        data: actions.payload,
        isLoading: false,
      };
    case EProfileViewActions.GetProfileFailure:
      return {
        ...state,
        errors: actions.errors,
        isLoading: false,
      };
    case EProfileViewActions.ClearGetProfile:
      return {
        ...state,
        data: null,
        errors: null,
        isLoading: false,
      };

    case EProfileViewActions.UpdateProfileAvatar:
      return {
        ...state,
        data: {
          ...state.data,
          avatar: actions.payload.url,
        },
      };
  }
  return state;
};
